import type { Amenity } from '@gyym/sdk'

import { AMENITY_LABELS } from '../constants'
import type { LocationFeatureSpecification } from '../types'

/**
 * Build amenityFeature array from facility amenities
 * Only includes amenities that are available (value: true)
 */
export const buildAmenityFeature = (
  amenities: Amenity,
): LocationFeatureSpecification[] => {
  const features: LocationFeatureSpecification[] = []

  for (const [key, value] of Object.entries(amenities)) {
    if (value === true) {
      const label = AMENITY_LABELS[key as keyof Amenity]
      if (label) {
        features.push({
          '@type': 'LocationFeatureSpecification',
          name: label,
          value: true,
        })
      }
    }
  }

  return features
}
